import React from 'react';
import { getBoxStyle, getTitleStyle, getTextStyle } from './ExtendedFooterBoxStyles';

interface ExtendedFooterBoxProps {
  bottomText?: boolean;
  children?: any;
  color?: string;
  link?: React.ReactNode;
  oblique?: boolean;
  padding?: string;
  squareBorder?: boolean;
  text: React.ReactNode;
  title: string;
}

export const ExtendedFooterBox: React.FC<ExtendedFooterBoxProps> = ({
  bottomText,
  children,
  color,
  link,
  oblique,
  padding,
  squareBorder,
  text,
  title,
}) => {
  const boxStyle = getBoxStyle(squareBorder, padding);
  const titleStyle = getTitleStyle(color);
  const textStyle = getTextStyle();
  return (
    <>
      <div className={`extended-footer-box ${boxStyle.className}`}>
        <span className={`extended-footer-title ${titleStyle.className}`}>{title}</span>
        <span
          className={`extended-footer-text ${textStyle.className}`}
          style={{ fontStyle: oblique ? 'oblique' : 'normal' }}
        >
          {text}
        </span>
        {bottomText && (
          <span className={`extended-footer-text ${textStyle.className} bottom`}>
            Read more{' '}
            <span className="extended-footer-text" style={{ textDecoration: 'underline' }}>
              {link}
            </span>
            .
          </span>
        )}
        {children}
      </div>
      {boxStyle.styles}
      {titleStyle.styles}
      {textStyle.styles}
    </>
  );
};
